import React, { useRef, useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Background, Page, Subpage, Images, Content, Title, Table, Breaker, Assinaturas } from "./style";
import Prefeitura from "../../../assets/Images/prefeitura.jpg";
import Fiec from "../../../assets/Images/fiec.png";
import PdfButtons from "../../../components/PdfButtons";
import api from "../../../services/api";
import Auth from "../../../services/auth";
import { useNavigate } from "react-router-dom";
import { Swal } from "../../../services/SwalTemplates";
import LoadingRH from "../../../components/Loading";

export default function PdfFechamentoCoordTotal() {
  const [IdCoord] = useState(Auth.id());
  const [fechamentos, setFechamentos] = useState([]);
  const [coordResponsavel, setCoordResponsavel] = useState("");
  const [data_inicio, setData_inicio] = useState("");
  const [data_fim, setData_fim] = useState("");
  const [idsCentroCusto, setIdscentroCusto] = useState([]); // <<< array vazio
  const [CentroCustos, setCentroCustos] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef();

  useEffect(() => {
    if (!data_inicio) return;

    setLoading(true);
    // Swal.fire({
    //   title: "Aguarde!",
    //   text: "O relatório está sendo gerado!",
    //   icon: "info",
    //   showConfirmButton: false,
    //   didOpen: () => Swal.showLoading(),
    // });
    FechamentoPdfCoord(IdCoord, data_inicio, data_fim, idsCentroCusto, navigate);
  }, [IdCoord, data_inicio, data_fim, idsCentroCusto, navigate]); // <<< sem loading

  async function FechamentoPdfCoord(IdCoord, data_inicio, data_fim, idsCentroCusto, navigate) {
    try {
      const res = await api.get(
        `/coord/fechamentopdfcoord?idUser=${IdCoord}` +
          `&idCentroCusto2=${idsCentroCusto.join("|")}` +
          `&data_inicio=${new Date(data_inicio).toLocaleDateString("en-ZA")}` +
          `&data_fim=${new Date(data_fim).toLocaleDateString("en-ZA")}`
      );
      setFechamentos(res.data.fechamentos);
      setCoordResponsavel(res.data.nome_coord_responsavel_pdf);
    } catch (error) {
      const { value } = await Swal.fire({
        title: "Atenção!",
        text: error?.response?.data?.error || "Não foi possível consultar!",
        icon: "warning",
        confirmButtonColor: "var(--blue-color)",
      });

      if (value) navigate(-1);
    } finally {
      // Swal.close();
      setLoading(false);
    }
  }

  useEffect(() => {
    setIdscentroCusto(location?.state?.idCentroCusto2 || "");
    setCentroCustos(location?.state?.centroCusto2 || "");

    if (location?.state?.data_inicio && location?.state?.data_fim) {
      const dataI = new Date(location.state.data_inicio);
      const dataF = new Date(location.state.data_fim);
      dataI.setDate(dataI.getDate() + 1);
      dataF.setDate(dataF.getDate() + 1);
      setData_inicio(dataI);
      setData_fim(dataF);
    }
  }, [location?.state]);

  // Centros de custo únicos para colunas dinâmicas
  const centrosCustoUnicos = useMemo(() => [...new Set(fechamentos.flatMap((f) => f.dados.map((d) => d.centro_custo)))], [fechamentos]);

  const titleCentros = useMemo(() => {
    // nomes selecionados vindos do location
    const sel = Array.isArray(CentroCustos) ? CentroCustos : [CentroCustos];
    // filtra pelos que aparecem em centrosCustoUnicos
    return sel.filter((name) => centrosCustoUnicos.includes(name));
  }, [CentroCustos, centrosCustoUnicos]);

  return (
    <Background>
      {!loading ? <PdfButtons /> : null}
      <Page>
        <Subpage>
          <Breaker ref={ref}>
            <Images>
              <img src={Fiec} alt="FIEC Logo" />
              <img src={Prefeitura} alt="Prefeitura Logo" />
            </Images>
            {loading ? (
              <Content
                style={{
                  height: "80vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <h3>O relatório está sendo gerado! Aguarde um momento...</h3>
                <LoadingRH />
              </Content>
            ) : (
              <Content>
                <Title>Apuração de Carga Horária - {titleCentros.join(" / ")}</Title>
                <Title>
                  Período de Apuração: {new Date(data_inicio).toLocaleDateString("pt-BR")} a{" "}
                  {new Date(data_fim).toLocaleDateString("pt-BR")}
                </Title>

                <Table border={1}>
                  <thead>
                    <tr>
                      <th>COD</th>
                      <th>Nome</th>
                      {centrosCustoUnicos.map((centro) => (
                        <th key={centro}>{centro}</th>
                      ))}
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fechamentos.map((f, idx) => {
                      const acumulado = {};
                      centrosCustoUnicos.forEach((c) => (acumulado[c] = 0));
                      f.dados.forEach((d) => {
                        acumulado[d.centro_custo] += d.carga_horaria2 || 0;
                      });
                      const total = Object.values(acumulado).reduce((a, b) => a + b, 0);
                      const styleTotal = total > 216 ? { color: "red", fontWeight: "bold" } : { fontWeight: "bold" };
                      return (
                        <tr key={idx}>
                          <td>{f.matricula_colaborador}</td>
                          <td>{f.colaborador}</td>
                          {centrosCustoUnicos.map((c) => (
                            <td key={c}>{Number(acumulado[c].toFixed(2)) || 0}</td>
                          ))}
                          <td style={styleTotal}>{total ? Number(total.toFixed(2)) : 0}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* opcional: <tfoot> para rodapé repetido */}
                </Table>

                <Assinaturas>
                  <div>
                    Coordenador
                    <br />
                    {coordResponsavel}
                  </div>
                </Assinaturas>
              </Content>
            )}
          </Breaker>
        </Subpage>
      </Page>
    </Background>
  );
}
